import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Scissors, Mail, Lock, Loader2 } from "lucide-react";

const BRAND_NAME = "Salon Bahadır Kersü";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error("E-posta ve şifre gerekli");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, {
        email,
        password
      });
      
      if (response.data.success) {
        login(response.data.token, response.data.user, "admin");
        toast.success("Giriş başarılı!");
        navigate("/admin");
      }
    } catch (error) {
      const message = error.response?.data?.detail || "Giriş başarısız";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#fafafa] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Scissors className="w-8 h-8 text-[#c9a96e]" />
            <span className="font-display text-2xl font-semibold text-[#1a1a2e]">{BRAND_NAME}</span>
          </div>
          <p className="font-accent text-sm text-[#c9a96e]">YÖNETİCİ PANELİ</p>
        </div>

        {/* Form Card */}
        <div className="bg-white border border-[#e5e7eb] rounded-xl p-8 shadow-sm" data-testid="admin-login-card">
          <h2 className="font-display text-xl text-[#1a1a2e] mb-6 text-center">Yönetici Girişi</h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="font-accent text-xs text-[#6b7280] mb-2 block">E-POSTA</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9ca3af]" />
                <Input
                  type="email"
                  placeholder="admin@elitebarber.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input-elite pl-12 h-12"
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div>
              <label className="font-accent text-xs text-[#6b7280] mb-2 block">ŞİFRE</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9ca3af]" />
                <Input
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-elite pl-12 h-12"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              className="btn-primary w-full h-12"
              disabled={loading}
              data-testid="admin-login-btn"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                "Giriş Yap"
              )}
            </Button>
          </form>

        </div>

        {/* Back to home */}
        <div className="text-center mt-6">
          <button
            onClick={() => navigate("/")}
            className="text-sm text-[#6b7280] hover:text-[#1a1a2e] transition-colors"
          >
            Ana sayfaya dön
          </button>
        </div>
      </div>
    </div>
  );
}
